
<article class="block type-flex">
    <div class="col-left">
        <header class="block-header">
            <h1 class="block-header-title">{{detail.Title}}</h1>
            <div class="block-header-text">
                <p [innerHTML]="detail.Description"></p>
            </div>
        </header>

        <section class="block-group">
            <h1 class="block-group-title">General information</h1>
            <button type="button" class="block-group-toggle-button" [ngClass]="{'is--active': tab1Active}" (click)="tab1Active = !tab1Active">
            <span class="icon is--icon-plus">
              <svg class="icon-svg">
                  <use xlink:href="assets/gfx/svg-sprite.svg#icon-plus"></use>
              </svg>
            </span>
            <span class="icon is--icon-min">
              <svg class="icon-svg">
                  <use xlink:href="assets/gfx/svg-sprite.svg#icon-min"></use>
              </svg>
            </span>
            </button>
            <div class="block-group-content">
                <dl class="block-group-list">
                    <dt class="block-group-heading">Detail number:</dt>
                    <dd class="block-group-item">{{detail.Number}}</dd>

                    <dt class="block-group-heading" *ngIf="detail.Categories?.length > 0">Categories:</dt>
                    <dd class="block-group-item">{{objArrayToString(detail.Categories)}}</dd>

                    <dt class="block-group-heading">Created on:</dt>
                    <dd class="block-group-item">{{detail.CreatedOn | date}}</dd>

                    <dt class="block-group-heading">Last revised on:</dt>
                    <dd class="block-group-item">{{detail.RevisedOn | date}}</dd>
                </dl>
            </div>
        </section>

        <section class="block-group" *ngIf="detail.Team?.length > 0">
            <h1 class="block-group-title">Team</h1>
            <button type="button" class="block-group-toggle-button is--active" [ngClass]="{'is--active': !tab2Active}" (click)="tab2Active = !tab2Active">
              <span class="icon is--icon-plus">
                <svg class="icon-svg">
                    <use xlink:href="assets/gfx/svg-sprite.svg#icon-plus"></use>
                </svg>
              </span>
              <span class="icon is--icon-min">
                <svg class="icon-svg">
                    <use xlink:href="assets/gfx/svg-sprite.svg#icon-min"></use>
                </svg>
              </span>
            </button>
            <div class="block-group-content">
                <dl class="block-group-list type-row">
                    <dd class="block-group-item" *ngFor="let member of detail.Team"><a href="#">{{member.Name}}</a></dd>
                </dl>
            </div>
        </section>

        <section class="block-group" *ngIf="projects?.length > 0">
            <h1 class="block-group-title">Used in following projects</h1>
            <button type="button" class="block-group-toggle-button" [ngClass]="{'is--active': !tab3Active}" (click)="tab3Active = !tab3Active">
              <span class="icon is--icon-plus">
                <svg class="icon-svg">
                    <use xlink:href="assets/gfx/svg-sprite.svg#icon-plus"></use>
                </svg>
              </span>
              <span class="icon is--icon-min">
                <svg class="icon-svg">
                    <use xlink:href="assets/gfx/svg-sprite.svg#icon-min"></use>
                </svg>
              </span>
            </button>
            <div class="block-group-content">
                <ul class="block-group-list type-hash">
                    <li class="block-group-item" *ngFor="let project of projects"><a [routerLink]="'/project/' + project.Id">{{project.Title}}</a></li>
                </ul>
            </div>
        </section>
        <section class="block-group type-options">
            <a href="file:///Users/Admin/Desktop/" target="open" class="block-group-folder-button">
                <span class="icon is--icon-folder">
                <svg class="icon-svg">
                  <use xlink:href="assets/gfx/svg-sprite.svg#icon-folder"></use>
                </svg>
            </span> Open detail folder
            </a>
        </section>
    </div>

    <div class="col-right type-project-detail">
        <section class="block-gallery" *ngIf="detail.MainImage">
            <ul class="block-gallery-list">
                <li class="block-gallery-list-item type-{{detail.MainImage.type}} is--active" [ngClass]="{'type-portrait': detail.MainImage.orientation === 'PORTRAIT', 'type-landscape': detail.MainImage.orientation === 'LANDSCAPE'}">
                    <figure class="block-gallery-item-image-crop">
                        <img [src]="detail.MainImage.ImageUrl" (load)="imageLoaded(detail.MainImage, $event)" />
                    </figure>
                </li>
            </ul>
        </section>


        <section class="block-gallery" *ngFor="let group of groupedImages" hidden>
            <h1 class="block-gallery-title">
                {{group.category}}
            </h1>
            <button type="button" class="block-gallery-toggle-button" [ngClass]="{'is--active': group.active}" (click)="group.active = !group.active">
                <span class="icon is--icon-min">
                    <svg class="icon-svg">
                        <use xlink:href="assets/gfx/svg-sprite.svg#icon-min"></use>
                    </svg>
                </span>
                <span class="icon is--icon-plus">
                    <svg class="icon-svg">
                        <use xlink:href="assets/gfx/svg-sprite.svg#icon-plus"></use>
                    </svg>
                </span>
            </button>
            <ul class="block-gallery-list">
                <li class="block-gallery-list-item type-{{image.type}}" [ngClass]="{'is--active': image.active, 'type-portrait': image.orientation === 'PORTRAIT', 'type-landscape': image.orientation === 'LANDSCAPE'}"
                    (click)="image.active = !image.active" *ngFor="let image of group.items">
                    <figure class="block-gallery-item-image-crop">
                        <img [src]="image.ImageUrl" (load)="imageLoaded(image, $event)" />
                    </figure>
                </li>
            </ul>
        </section>

    </div>

</article>